import useSWR from 'swr';
import { FetchResult, TaskHistory } from '../entities';

type Result = FetchResult & { data: TaskHistory[] };

export function useTaskHistory(id: string): Result {
  const { data, error, mutate } = useSWR(`/tasks/${id}/history`);

  return {
    data: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}
